/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton, IconButtonLabelPlacement} from '@ion/dls/src/components/buttons/IconButton';
import {ColumnChooserIcon} from '@ion/dls/src/icons/ColumnChooserIcon';
import useThemeContext from '../../theme/useThemeContext';
import Tooltip from '../tooltip/Tooltip';

export const ColumnChooserTooltip = function(props) {
  return <Tooltip arrow {...props} />;
};

// defines the container props ...
export type ColumnChooserButtonProps = {
  onShowColumnChooser: (params?: boolean) => void,
  currentLabelPlacement?: IconButtonLabelPlacement
};

/**
 * The ColumnChooserButton provides the ColumnChooser Icon Button which provides the state
 * and labels common amongst the grid
 *
 * ```typescript
 *   import {ColumnChooserButton} from '@ion/dls/src/components/buttons/';
 *
 *   <ColumnChooserButton onShowColumnChooser={onShowColumnChooser} />
 * ```
 */
export const ColumnChooserButton = ({
  onShowColumnChooser,
  currentLabelPlacement = IconButtonLabelPlacement.STACKED
}: ColumnChooserButtonProps) => {
  const {isCurrent: isCurrentTheme} = useThemeContext();
  const label                       = translate('common:columnChooser.title');
  const button                      = (
    <div>
      <IconButton icon={<ColumnChooserIcon />}
        label={isCurrentTheme ? label : undefined}
        labelPlacement={currentLabelPlacement}
        onClick={onShowColumnChooser} />
    </div>
  );

  if (isCurrentTheme) {
    return button;
  }

  return (
    <ColumnChooserTooltip title={label}>
      {button}
    </ColumnChooserTooltip>
  );
};

export default ColumnChooserButton;
